// Whether the user's organisation holds a license for an AI app (e.g. 'RiskIQ'), from the licensedApps list /api/me
// returns (ADO 91627). Fails closed: no list means no license.
export const hasAppLicense = (user: { licensedApps?: string[] | null } | null | undefined, app: string): boolean =>
    !!user?.licensedApps?.some((licensed) => licensed.toLowerCase() === app.toLowerCase());
